import React, { useEffect, useState, useRef } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from 'react-router-dom';
import { findUser } from '../_actions/user_action';
import { listDevice, resetDevice, getGraphData, findSetting } from '../_actions/user_action';

import '../css_mobile/style_home.css';
import '../css_mobile/style_guide.css';
import '../css_mobile/style_globals.css';

import { Button, Box } from '@mui/material';

import mobileMenu from "./images/menu-line-horizontal.png";
import mobileBi from "./images/mobile-bi.png";
// import appIcon from "./images/app-icon.png";
// import googlePlay from "./images/google-play.png";

// 사용자 정보
import MobileMapContainer from './MobileHomeMapContainer';
// 실시간 측정치
import MobileRealtimeContainer from './MobileHomeRealtimeContainer';
// 기간별 측정 이력
import MobileHomePrintList from './MobileHomePrintList';
// 기본정보 설정
import MobileSettingBasic from './MobileSettingBasic';
// 경고설정
import MobileSettingAlarm from './MobileSettingAlarm';
// 고객지원
import MobileCustomer from './MobileCustomer';
import { getUserAccount, getIsLogin, clearSession } from '../utils/session';

import * as Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import Accessibility from 'highcharts/modules/accessibility';

const menuItems = [
    { key: 'userInfo', label: '사용자 정보' },
    { key: 'realTime', label: '실시간 측정치' },
    { key: 'printList', label: '기간별 측정 이력' },
    { key: 'settingBasic', label: '기본정보 설정' },
    { key: 'settingAlarm', label: '경고설정' },
    { key: 'customerSupport', label: '고객지원' },
]

// Accessibility 모듈 초기화
Accessibility(Highcharts);

let graphType = "NH3";
let graphDevice = "";

const graphOptions = [
    { value: 'NH3', label: 'NH3', color: '#008080' },
    { value: 'H2S', label: 'H2S', color: '#7030A0' },
    { value: 'TEMP', label: '온도', color: '#FF6600' },
    { value: 'HUM',  label: '습도', color: '#0070C0' },
];

function MobileHome() { 
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const userAccount = getUserAccount() || {};
    const isLogin = getIsLogin();

    const onLogoutHandler = (event) => {
        event.preventDefault();
        clearSession();
        window.location.replace('/mobile');
    };
    // console.log("Mobile Home - isLogin", isLogin);

    // <!--
    // Start - 사용자 정보  User info
    const [isReady, setIsReady] = useState(false);
    const [userInfo, setUserInfo] = useState();
    const [userTerm, setUserTerm] = useState(60)

    useEffect(() => {
        if (!isLogin || !userAccount) {
            navigate('/mobile');
            return;
        }

        let body = {
            email: userAccount.email
        };

        dispatch(findUser(body)).then(response => {
            if (response.payload.findSuccess) {
                let userInfo = response.payload.userInfo;
                // console.log('userInfo: ', userInfo);
                setUserInfo(userInfo);

                body = {
                    id: userAccount.email,
                    sensorMain: userAccount.sensorMain
                };

                dispatch(findSetting(body)).then(response => {
                    if (response.payload.findSuccess) {
                        let settingInfo = response.payload.settingInfo;
                        if (settingInfo) {
                            setUserTerm(settingInfo.userTerm);
                        }
                    }
                });

                setIsReady(true);
            }
        })
        .catch((err) => console.log(err));
    }, [isReady]);

    // 측정 그래프  Measurement graph
    const [graphData, setGraphData] = useState([]);

    const initialOptions = {
        title: {
            text: ''
        },
        xAxis: {
            categories: []
        },
        yAxis: {
            title: {
                text: ''
            }
        },
        tooltip: {
            enabled: true,
            headerFormat: '',
            pointFormat: '{point.y:.f} ppm'
        },
        series: [],
        credits: {
            enabled: false // 로고 숨기기
        },
        // 차트 옵션 설정
        accessibility: {
            enabled: true // 접근성 활성화 (기본값)
        }
    };
    const [options, setOptions] = useState(initialOptions);

    const [selectedSensor, setSelectedSensor] = useState(null);
    const [targetState, setTargetState] = useState(null);

    useEffect(() => {
        // 초기 그래프 표시
        // graphDevice = userAccount.sensorMain;
        if (graphDevice === "") {
            const sensorDevice = userAccount.sensorNode;
            // console.log('sensorDevice: ', sensorDevice);
            const firstValidDevice = sensorDevice.find(device => device.device.trim() !== '');
            if (firstValidDevice !== '') {
                graphDevice = firstValidDevice.device;
                setTargetDevice(graphDevice);
            }
            // console.log('graphDevice: ', graphDevice);
            const firstValidSensor = sensorDevice.find(sensor => sensor.value.trim() !== '');
            if (firstValidSensor !== '') { 
                // console.log('firstValidSensor:', firstValidSensor);
                setSelectedSensor(firstValidSensor.value);
            }
        }
        displayGraph();
    
        // 타이머 설정
        const timer = setInterval(() => {
            if (graphData.length > 0) {
                makeGraph(graphData);
            } else {
                if (graphType && graphDevice) {
                    displayGraph();
                    // console.log('Mobile Home Reload - displayGraph');
                }
            }
        }, userTerm * 1000);
    
        // 클린업
        return () => clearInterval(timer);
    }, [graphType, graphDevice, userAccount.sensorMain, userTerm]);
    
    const isGraphFetching = useRef(false)

    const displayGraph = () => {
        if (isGraphFetching.current) return;
        isGraphFetching.current = true;

        // console.time("⏱ displayGraph fetch time");

        const today = new Date();
        const yesterday = new Date();

        let body = {
            device: graphDevice,
            startDate: yesterday,
            endDate: today
        };
        
        // console.log('displayGraph body:', body);
        setIsReady(false);
        dispatch(getGraphData(body)).then(response => {
            // console.timeEnd("⏱ displayGraph fetch time");
            isGraphFetching.current = false;
            // console.log('displayGraph', response.payload);
            if (response.payload.findSuccess) {
                let graphData = response.payload.graphData;
                setGraphData(graphData);
                // if (graphData.length > 0) {
                if (graphData) {
                    makeGraph(graphData);
                    setIsReady(true);
                }
            }
        });
    };

    const [selectedGraphType, setSelectedGraphType] = useState(graphType);

    const onChangeGraphType = (valueOrEvent) => {
        const value = typeof valueOrEvent === 'string'
            ? valueOrEvent
            : valueOrEvent.target.value;
        graphType = value;
        setSelectedGraphType(value);
        console.log('onChangeGraphType -', graphType);
        
        setGraphData([]);
        if (graphData.length > 0) {
            makeGraph(graphData);
        } else {
            if (graphType && graphDevice) {
                displayGraph();
                console.log('Mobile Home onChangeGraphType - displayGraph');
            }
        }
    };

    const onChangeGraphDevice = (targetDevice) => {
        graphDevice = targetDevice;
        setTargetDevice(targetDevice);
        console.log('onChangeGraphDevice -', graphDevice);

        setGraphData([]);
        if (graphData.length > 0) {
            makeGraph(graphData);
        } else {
            if (graphType && graphDevice) {
                displayGraph();
                console.log('Mobile Home onChangeGraphDevice - displayGraph');
            }
        }
    };

    const makeGraph = (graphData) => {
        const intervalMinutes = 1; // 5;
        const arrayCount = 12; // 1시간을 5분 단위로 나눔 = 12개
    
        // 데이터 중 가장 최근 시간 찾기
        const timestamps = graphData.map(data => new Date(data.KSTTime).getTime());
        const maxTimestamp = Math.max(...timestamps);
    
        // 가장 최근 데이터 시간을 기준으로 1시간 전을 시작 시간으로 설정
        const nowDate = new Date(maxTimestamp);
        // const beforeDate = new Date(nowDate.getTime() - 60 * 60 * 1000); // 1시간 전
    
        const timeSlots = [];
        const groupedValues = Array(arrayCount).fill().map(() => []);
    
        // 시간 슬롯을 최신 데이터를 중심으로 생성
        for (let i = 0; i < arrayCount; i++) {
            const slotStart = new Date(nowDate.getTime() - (arrayCount - 1 - i) * intervalMinutes * 60 * 1000);
            const slotEnd = new Date(slotStart.getTime() + intervalMinutes * 60 * 1000);
            // 유효하지 않은 날짜일 경우 기본값으로 설정
            if (isNaN(slotStart.getTime()) || isNaN(slotEnd.getTime())) continue;
            const label = `${String(slotStart.getHours()).padStart(2, '0')}:${String(slotStart.getMinutes()).padStart(2, '0')}`;
            timeSlots.push({ label, slotStart, slotEnd });
        }
    
        graphData.forEach((data) => {
            // console.log('data:', data);
            
            const kstTime = data.KSTTime;
            if (!kstTime) return;
    
            const dataDate = new Date(kstTime);
    
            // 각 슬롯의 범위 안에 있는지 확인하여 데이터를 삽입
            let matched = true;
            for (let i = 0; i < timeSlots.length; i++) {
                const { slotStart, slotEnd } = timeSlots[i];
    
                // 최신 데이터를 포함하도록 슬롯 종료 시간을 보정
                if (dataDate >= slotStart && dataDate < slotEnd) {
                    // 1) graphType 에 맞는 원본 값 꺼내기
                    const raw = {
                        TEMP: data.Temperature,
                        HUM:  data.Humidity,
                        NH3:  data.NH3,
                        H2S:  data.H2S
                    }[graphType] ?? data.NH3;
                    // 2) 숫자로 변환 (parseFloat 만 사용)
                    const numeric = parseFloat(raw);
                    if (!isNaN(numeric)) {
                        groupedValues[i].push(numeric);
                        matched = true;
                    }
                    break;
                }
            }
    
            // 만약 어떤 슬롯에도 포함되지 않는 최신 데이터라면 마지막 슬롯에 강제로 포함
            if (!matched) {
                const raw = {
                    TEMP: data.Temperature,
                    HUM:  data.Humidity,
                    NH3:  data.NH3,
                    H2S:  data.H2S
                }[graphType] ?? data.NH3;
                const numeric = parseFloat(raw);
                if (!isNaN(numeric)) {
                    groupedValues[arrayCount - 1].push(numeric);
                }
            }
        });
    
        const averaged = groupedValues.map(values => {
            if (values.length === 0) return null;
            // const sum = values.reduce((a, b) => a + b, 0);
            // return Math.round(sum / values.length);
            return values[values.length - 1];
        });
    
        // 최소값 계산 (온도는 음수 허용, 그 외는 0)
        const minValue = graphType === 'TEMP'
            ? Math.min(...averaged.filter(v => v !== null)) - 5
            : 0;
        const maxValue = Math.max(...averaged.filter(v => v !== null)) + 10;
    
        // X축에 표시할 시간을 문자열로 변환
        const xLabels = timeSlots.map(slot => slot.label);
    
        const tempOptions = {
            ...initialOptions,
            xAxis: { categories: xLabels },
            yAxis: {
                title: {
                    text: { H2S: "황화수소 (ppm)", TEMP: "온도 (°C)", HUM: "습도 (%)" }[graphType] || "암모니아 (ppm)"
                },
                allowDecimals: false,
                min: minValue,
                max: maxValue,
            },
            tooltip: {
                enabled: true,
                headerFormat: '',
                pointFormat: {
                    H2S: '{point.y:.2f} ppm',
                    TEMP: '{point.y:.2f} °C',
                    HUM: '{point.y:.3f} %',
                }[graphType] || '{point.y:.2f} ppm'
            },
            series: [{
                name: { H2S: "황화수소", TEMP: "온도", HUM: "습도" }[graphType] || "암모니아",
                data: averaged
            }]
        };
    
        setOptions(tempOptions);
    };

    // 실시간 장비상태  Real-time Equipment status
    const [deviceListInfo, setDeviceListInfo] = useState([]);
    // Node Sensor Fail
    // Offline - 12시간 연속 측정 데이터 송신 누락
    // Error - 5회 연속 측정 데이터 송신 누락, 12시간 동안 측정 데이터 3회 이상 송신 누락
    const [failCountInfo, setFailCountInfo] = useState({id: '', failCount: 0});

    useEffect(() => {
        // 초기 상태 표시
        displayStatus();
    
        // 타이머 설정
        const timer = setInterval(() => {
            if (userInfo) {
                displayStatus();
                console.log("Mobile Home Reload - displayStatus");
            }
        }, userTerm * 1000);
    
        // 클린업
        return () => clearInterval(timer);
    }, [userInfo, userTerm]);    

    const displayStatus = () => {
        let body = {
            id: userAccount.email
        };
    
        dispatch(listDevice(body)).then(response => {
            if (response.payload.listSuccess) {
                let deviceList = response.payload.deviceList;
                // console.log('displayStatus: ', deviceList);
                setDeviceListInfo(deviceList);
            }
        });
    };

    const [targetDevice, setTargetDevice] = useState('');

    useEffect(() => {
        // console.log('targetDevice changed:', targetDevice);
    }, [targetDevice]);

    const [activeSection, setActiveSection] = useState('userInfo');

    const [menuOpen, setMenuOpen] = useState(false)
    
    return (
        <div className="main">
            <div className="frame">
                <img 
                    className="huge-icon-menu" 
                    src={mobileMenu} 
                    alt="메뉴"
                    onClick={() => setMenuOpen(prev => !prev)}
                    style={{ cursor: 'pointer' }}
                />
                <div className="text-wrapper-EMS">
                    <img className="image" src={mobileBi} /> EMS
                </div>

                <>
                {menuOpen && (
                    <div className="dropdown-menu">
                    {menuItems.map(item => (
                        <div className="text-wrapper-4"
                            key={item.key}
                            onClick={() => {
                                setActiveSection(item.key)
                                setMenuOpen(false)
                            }}
                            style={{
                                padding: '8px 12px',
                                cursor: 'pointer',
                                whiteSpace: 'nowrap',
                                fontWeight: activeSection === item.key ? 'bold' : 'normal',
                            }}
                        >
                            {item.label}
                        </div>
                    ))}
                    </div>
                )}
                </>
            </div>
            <div className="div">
                <div className="frame-2">
                    <div className="frame-3">
                        <div className="text-wrapper">{userAccount.company}</div>
                        <div className="text-wrapper-2">{userAccount.email}</div>
                    </div>
                    <div className="logout-btn">
                        <div className="div-wrapper">
                            <div className="text-wrapper-3" onClick={onLogoutHandler}>로그아웃</div>
                        </div>
                    </div>
                </div>

                {activeSection === 'userInfo' && isReady && userInfo && (
                    <div className="frame-4">
                        <div className="frame-5">
                            <div className="text-wrapper-5">사용자 정보</div>
                            {/* <div className="text-wrapper-6">User Info</div> */}
                        </div>
                        {
                            isReady && userInfo &&
                            <MobileMapContainer userInfo={userInfo} />
                        }
                    </div>
                )}

                {activeSection === 'realTime' && isReady && userInfo && (
                    <>
                    <div className="frame-real-1" style={{ height: '34%' }}>
                        <div className="frame-7">
                            <div className="text-wrapper-5">실시간 장비상태</div>
                            {/* <div className="text-wrapper-6">Real Time Equipment Status</div> */}
                        </div>
                        <div
                            className="frame-real-sub-1"
                            style={{
                                overflowX: 'hidden',
                                overflowY: 'hidden',
                            }}
                        >
                            <div className="frame-real-sub-child">
                                <div className="frame-real-sub-child-1">
                                    <div className="text-wrapper-real-1">장비 Part No.</div>
                                    <div className="text-wrapper-real-2">센서 상태</div>
                                    {/* <div className="text-wrapper-real-3">신호세기</div>
                                    <div className="text-wrapper-real-3">신호품질</div> */}
                                </div>
                                
                                {
                                    deviceListInfo &&
                                    deviceListInfo.map((deviceInfo, index) => (
                                        deviceInfo.sensorId && deviceInfo.sensorId.length === 16 && (
                                            <div 
                                                className="frame-real-sub-child-2" 
                                                key={`device-${index}`}
                                                onClick={() => {
                                                    setSelectedSensor(deviceInfo.sensorNumber);
                                                    onChangeGraphDevice(deviceInfo.sensorId);
                                                }}
                                                style={{
                                                    cursor: 'pointer',
                                                    backgroundColor: selectedSensor === deviceInfo.sensorNumber ? '#d3e7ff' : 'transparent',
                                                    color: selectedSensor === deviceInfo.sensorNumber ? '#0056b3' : 'black'
                                                }}
                                            >
                                                <div className="text-wrapper-real-4">{deviceInfo.sensorNumber}</div>
                                                <div
                                                    className="text-wrapper-real-5"
                                                    style={{
                                                        color:
                                                        deviceInfo.state === "Online" ? '#1a9f55' :       // 녹색: 정상동작
                                                        deviceInfo.state === "Offline" ? '#d9822b' :      // 주황색: 점검필요
                                                        deviceInfo.state === "Error" ? '#e02424' :        // 빨간색: 통신오류
                                                        '#999999'                                         // 회색: 대기상태 또는 없음
                                                    }}
                                                    >
                                                    {deviceInfo.state === "Online" && '정상동작'}
                                                    {deviceInfo.state === "Offline" && '점검필요'}
                                                    {deviceInfo.state === "Error" && '통신오류'}
                                                    {deviceInfo.state === "" && '대기상태'}
                                                </div>
                                                {/* <div className="text-wrapper-real-6"
                                                style={{
                                                    color: 
                                                        deviceInfo.stateRssi.includes("나쁨")
                                                        ? '#e02424' // 빨간색: 나쁨 or 매우 나쁨
                                                        : '#4e82eb' // 파란색: 매우 좋음 or 좋음
                                                }}>
                                                    { deviceInfo.state === "Online" && deviceInfo.stateRssi }
                                                </div>
                                                <div className="text-wrapper-real-6"
                                                style={{
                                                    color: 
                                                        deviceInfo.stateSnr.includes("나쁨")
                                                        ? '#e02424' // 빨간색: 나쁨 or 매우 나쁨
                                                        : '#4e82eb' // 파란색: 매우 좋음 or 좋음
                                                }}>
                                                    { deviceInfo.state === "Online" && deviceInfo.stateSnr }
                                                </div> */}
                                            </div>
                                        )
                                    ))
                                }
                            </div>
                        </div>
                        <div class="mobile-signal-grid">
                            <div class="mobile-row mobile-header">
                                <div>신호세기</div>
                                <div>신호품질</div>
                                <div>신호상태</div>
                            </div>
                            <div class="mobile-row">
                                <div>-1 ~ -60</div>
                                <div>+10 이상</div>
                                <div class="mobile-status very-good">매우 좋음</div>
                            </div>
                            <div class="mobile-row">
                                <div>-61 ~ -80</div>
                                <div>+0.5 ~ 9.9</div>
                                <div class="mobile-status normal">보통</div>
                            </div>
                            <div class="mobile-row">
                                <div>-81 ~ -100</div>
                                <div>-5 ~ +0.4</div>
                                <div class="mobile-status bad">나쁨</div>
                            </div>
                            <div class="mobile-row">
                                <div>-101 이상</div>
                                <div>-5 이하</div>
                                <div class="mobile-status very-bad">매우 나쁨</div>
                            </div>
                        </div>
                    </div>

                    <div className="frame-6">
                        <div className="frame-7">
                            <div className="text-wrapper-5">실시간 측정치</div>
                            {/* <div className="text-wrapper-6">Real Time</div> */}
                        </div>
                        <div className="frame-8">
                            <div className="frame-9">
                                <div className="bar-components">
                                    <div className="frame-10">
                                    {
                                        isReady && userInfo && targetDevice &&
                                        <MobileRealtimeContainer key={targetDevice} userInfo={userInfo} targetDevice={targetDevice} />
                                    }
                                    </div>
                                    
                                    <Box sx={{ display: 'flex', gap: 1 }}>
                                        {graphOptions.map((opt) => {
                                        const isSelected = selectedGraphType === opt.value;
                                        return (
                                            <Button
                                                key={opt.value}
                                                variant="outlined"
                                                value={opt.value}
                                                onClick={() => onChangeGraphType(opt.value)}
                                                sx={{
                                                flex: 1,           // 버튼마다 동일 가중치로 폭 분배
                                                minWidth: 0,       // 텍스트가 길 때도 줄바꿈 없이 overflow 방지
                                                backgroundColor: isSelected ? opt.color : '#FFFFFF',
                                                color: isSelected ? '#FFFFFF' : opt.color,
                                                fontWeight: 'bold',
                                                padding: '2px 14px',
                                                border: `2px solid ${opt.color}`,
                                                textTransform: 'none',
                                                transition: 'background-color 0.2s, color 0.2s',
                                                '&:hover': {
                                                    backgroundColor: opt.color,
                                                    color: '#FFFFFF',
                                                },
                                                }}
                                          >
                                                {opt.label}
                                            </Button>
                                        );
                                        })}
                                    </Box>

                                    {
                                        isReady && userInfo &&
                                        <>
                                        <div className="frame-16">
                                            <div style={{ width: "100%" }}>
                                                <HighchartsReact
                                                    highcharts={Highcharts}
                                                    options={options}
                                                />
                                            </div>
                                        </div>
                                        </>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    </>
                )}

                {activeSection === 'printList' && (
                    <div className="frame-change">
                        <div className="frame-7">
                            <div className="text-wrapper-5">기간별 측정 이력</div>
                        </div>
                        {
                            <MobileHomePrintList />
                        }
                    </div>
                )}

                {activeSection === 'settingBasic' && (
                    <div className="frame-change" style={{ height: '73%' }}>
                        <div className="frame-7">
                            <div className="text-wrapper-5">기본정보 설정</div>
                        </div>
                        {
                            <MobileSettingBasic />
                        }
                    </div>
                )}

                {activeSection === 'settingAlarm' && (
                    <div className="frame-change" style={{ height: '80%' }}>
                        <div className="frame-7">
                            <div className="text-wrapper-5">경고설정</div>
                        </div>
                        {
                            <MobileSettingAlarm />
                        }
                    </div>
                )}

                {activeSection === 'customerSupport' && (
                    <div className="frame-change" style={{ height: '60%' }}>
                        <div className="frame-7">
                            <div className="text-wrapper-5">고객지원</div>
                        </div>
                        {
                            <MobileCustomer />
                        }
                    </div>
            )}
            </div>
            <div className="rectangle-4"></div>
        </div>
    );
}

export default MobileHome;
